module.exports = __webpack_public_path__ + "static/media/minecraft-1.5b061ead.png";